import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import PredictiveIntelligenceIsTransforming from '../components/PredictiveIntelligenceIsTransforming'

export default function HowPredictiveIntelligenceIsTransformingB2BDemandGeneration() {
  return (
    <div>
      <Header1/>
      <PredictiveIntelligenceIsTransforming/>
      <Footer/>
    </div>
  )
}
